/** Parse decimal input consistently, retaining invalid text for AJV type validation. */
export function numberInputValue(text: string): number | string | undefined {
	if(text === "") {
		return undefined;
	}

	const value = Number(text);
	const decimal = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/;

	return decimal.test(text.trim()) && Number.isFinite(value) ? value : text;
}
